function updateHeaderCartCount() {
    $.getJSON('/cart.js', function(cart) {
        var itemCount = cart.item_count;
        var headerCartCountElement = $('.site-header-cart--count');
        headerCartCountElement.attr('data-header-cart-count', itemCount);
        if(itemCount > 0) {
            headerCartCountElement.addClass('visible');
        } else {
            headerCartCountElement.removeClass('visible');
        }
    });
}


$(document).ready(function() {
    $(document).on('click', '.comp-product-button', function(event) {
        event.preventDefault();
        event.stopPropagation();

        var compProductForm = $(this).closest('form');
        if (!compProductForm.length) {
            return;
        }

        var formData = new FormData(compProductForm[0]);
        var compProductItem = $(this).closest('.complementary-product');
        var title = $('.complementary-products__title');

        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: formData,
            processData: false,
            contentType: false,
            dataType: 'json',
            success: function(response) {
                $(document).trigger("cartItemAdded");
                compProductItem.hide();

                // Check if there are no more '.comp-product-button' buttons visible
                if ($('.comp-product-button:visible').length === 0) {
                    title.hide(); // Hide the title if no buttons are visible
                }

                var cartDrawer = document.getElementById('cart-drawer');
                var cartBackdrop = document.querySelector('.cart-drawer-backdrop');
                if (cartDrawer) {
                    cartDrawer.classList.add('open');
                    if (cartBackdrop) {
                        cartBackdrop.style.display = 'block';
                    }
                    document.body.classList.add('no-scroll');
                }
            },
            error: function() {
                alert("Failed to add item to cart.");
            }
        });
    });
});